import React from 'react'
import { Link } from 'react-router-dom'

const JumbotronCover = ({
  title,
  description,
  primaryAction,
  secondaryAction,
  media,
  className = 'mt-40 px-4 md:p-8',
}) => {
  const renderAction = (action, variantClass) => {
    if (!action) return null

    const commonClass = `${variantClass} btn-lg mt-6 flex items-center gap-2 w-max`

    if (action.onClick) {
      return (
        <button onClick={action.onClick} className={commonClass}>
          {action.label}
        </button>
      )
    }

    if (action.to) {
      return (
        <Link to={action.to} className={commonClass}>
          {action.label}
        </Link>
      )
    }

    return (
      <a href={action.href} target={action.external ? '_blank' : undefined} rel={action.external ? 'noreferrer' : undefined} className={commonClass}>
        {action.label}
      </a>
    )
  }

  return (
    <div className={`${className} jumbotron-cover`}>
      <div className={`${media ? 'bg-black px-4 md:p-16 py-16 jumbotron jumbotron-with-media' : 'bg-black px-4 md:p-20 md:px-32 py-20 jumbotron'} jumbotron-rounded`}>
        <div className="jumbotron-copy">
          <div data-aos="fade-up" className="heading-three text-center md:text-left text-white">
            {title}
          </div>

          {description ? (
            <p data-aos="fade-up" className="base-text text-white mt-4 text-center md:text-left">
              {description}
            </p>
          ) : null}

          <div className="flex flex-col sm:flex-row justify-center gap-4 md:justify-start">
            {renderAction(primaryAction, 'btn btn-primary')}
            {renderAction(secondaryAction, 'btn btn-alt')}
          </div>
        </div>

        {media ? (
          <div className="jumbotron-media" data-aos="zoom-in-up">
            <img src={media.src} alt={media.alt || ''} loading="lazy" />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default JumbotronCover
